// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"15070363","453":"f9af8ee5"}[chunkId] + ".chunk.js";
};